import BeCoMap from './map/map.js';
import $ from 'jquery';
import Observable from './observer.js';
import API from './network/network.js';
import { getSiteIdentifier, getFloorIdentifier } from './network/util.js';
import { t } from './i18n/i18n.js';
import { toLocalTimeZone }  from './utils.js';
//import 'script-loader!./externaljs/ms-dropdown/jquery.dd.min.js';



//Styles
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

//Driver js
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import '../styles/tutorial/tutorial.scss';

var mapTemplate = require("../templates/map.handlebars");
var loaderTemplate = require("../templates/loader.handlebars");
var legendTemplate = require("../templates/map-legend.handlebars");
var headerTemplate = require("../templates/header.handlebars");
var feedBackTemplate = require("../templates/feedback.handlebars");
const updateMap = app => app.saveData();
const drawObserver = new Observable();

const menu = {
	account :{
		name : "My Account",
		url : SERVICE_URL 
	},
	sites :{
		name : "Sites",
		url : SERVICE_URL
	},
	docs :{
		name : "Docs",
		url : SERVICE_URL
	},
	support :{
		name : "Support",
		url : SERVICE_URL
	},
	logout :{
		name : "Sign out",
		url : SERVICE_URL
	}
};


export default class Application {

	constructor() {
		this.map;
		this.siteIdentifier;
		this.floorIdentifier;
		this.api = new API();
		this.buildInFlight;

	}

	init(){
		$( "body" ).append(loaderTemplate);
		
		
		if(!this.checkRequestparams()){
			$("#beco-loader").hide();
			$("#beco-error").show();
			$("#beco-text").text(t('site-conf-missing'));
		}else {
			// Check session 
			$("#beco-loader").show();
			$("#beco-error").hide();
			$("#beco-text").text(t('cheking-auth'));
			let _this = this;
			this.api.checkSession().then(function (response) {
			    $("#beco-text").text(t('fetching-map-data'));
			    // Load Data 
			    _this.api.getSiteData(_this.siteIdentifier, _this.floorIdentifier).then(function (response) {
			    	//Init map
					$(".container-loader").hide();
					$("#beco-wrapper").append(mapTemplate);
					//$("#beco-wrapper").append(menuTemplate);
					_this.initMap(response.data);
					$( "body" ).append(legendTemplate);
					$( "body" ).append(headerTemplate);
					$( "body" ).append(feedBackTemplate);
					$(".error-parent").hide();
					$(".success-or-error").hide();
					_this.buildAccountMenu();

					if (response.data.write){
				        $( "#save-data" ).bind( "click", function(event) {
				            event.preventDefault();
				            _this.saveData();
				        });
			    	} else {
			    		$( "#save-data" ).hide();
					}
					
					$("#feedbackSubmit").bind( "click" ,function(event){
						var data  = $("#message-text").val();
						_this.saveFeedback(data);
					});	

					setTimeout(function(){ 
						if(localStorage.getItem('guideUIcompleted')){
							
						}else{
							_this.showTutorial();
						} 
					}, 1000);
					
					$(document).on('click',".driver-close-btn", function(){
						localStorage.setItem('guideUIcompleted',true);
					});
					
			    }).catch(function (error) {
				    $("#beco-loader").hide();
					$("#beco-error").show();
					if(error.status = 403){
						$("#beco-text").text(t('permission-failed'));
					}else {
						$("#beco-text").text(t('invalid-site-config'));
					}
					
				});

				

			});
			 
			
			
		}
	}

	initMap(siteData) {
		this.map = new BeCoMap(siteData,this.api);
		this.map.init();
		this.getData(siteData);
		//this.attachObserver(); This need to sync data to firebase
	}

	checkRequestparams(){
		 
		try {
  			this.siteIdentifier = getSiteIdentifier();
		}
		catch(err) {
	  		console.log(err);
		} 

		try {
  			this.floorIdentifier = getFloorIdentifier();
		}
		catch(err) {
	  		console.log(err);
		} 

		return this.siteIdentifier && this.floorIdentifier;
	}

	getMap(){
		return this.map;
	}

	saveData(){
		if (this.buildInFlight) return;
		this.buildInFlight = true;
		$("#save-data").removeClass('btn-beco-save');
		$("#save-data").addClass('btn-beco-saved');

		let data = this.map.getFeatures();
		var _this = this;
		this.api.saveMapData(this.siteIdentifier, this.floorIdentifier,data).then(function (response) {
			
			if(response.status==210){
				$("#save-error").append("<p>"+t('connected-floor-save-error')+"</p>");
				// alert(t('connected-floor-save-error'));
			} else if(response.status==211){
				$("#save-error").append("<p>"+t('floor-build-in-progrss')+"</p>");
				// alert(t('floor-build-in-progrss'));
			} else if(response.status==212){
				$("#save-error").append("<p>"+t('save-error-invalid-floor')+"</p>");
				// alert(t('save-error-invalid-floor'));
			} else if(response.status==209){
				$("#save-error").append("<p>"+result.data.email+" is editing this floor </p>");
				// alert(result.data.email+" is editing this floor");
			}else if(response.status==200){
				$("#update_text").html("Last saved by "+response.data.updated_by_user+" at ");
				$("#update_time").html(toLocalTimeZone( Date.now() ));
			}
			_this.buildInFlight = false;

			$("#save-data").removeClass('btn-beco-saved');
			$("#save-data").addClass('btn-beco-save');	
			setTimeout(function() {
		    	$("#save-error").children().first().remove();
			}, 5000);
					
	    }).catch(function (error) {
			_this.buildInFlight = false;
			$("#save-error").append("<p>"+t('save-error-exception')+"</p>");
			$("#save-data").removeClass('btn-beco-saved');
			$("#save-data").addClass('btn-beco-save');
			setTimeout(function() {
		    	$("#save-error").children().first().remove();
			}, 5000);
		});


		
		//const result =  await this.api.saveData(this.siteIdentifier, this.floorIdentifier, data);
		
		
		 
		// this.buildInFlight = false;

		// $("#save-data").removeClass('btn-beco-saved');
		// $("#save-data").addClass('btn-beco-save');
	}

	async saveFeedback(feedback){
		const result =  await this.api.saveFeedback(this.siteIdentifier, feedback);
		$("#message-text").val('');
		$(".feedback-form").hide();
		$(".success-or-error").show();
		if(result == 200){
			$(".success-parent").show();
			setTimeout(function(){ 
				$("#myModal").modal('toggle');
				$(".success-parent").hide();
				$(".feedback-form").show();
				$(".success-or-error").hide();
			}, 2000);
		}else{
			$(".success-parent").hide();
			$(".error-parent").show();
			setTimeout(function(){ 
				$("#myModal").modal('toggle');
				$(".error-parent").hide();
				$(".feedback-form").show();
				$(".success-or-error").hide();
			}, 2000);

		}
		
	}

	async getData(siteData){
		const result =  await this.api.getData(this.siteIdentifier, this.floorIdentifier);
		if(result.map_data) this.map.setData(result.map_data);
		if(result.mod_time){
			(result.build_status) ? $("#update_text").html("Last built by "+result.updated_by_user+" at ") : $("#update_text").html("Last saved by "+result.updated_by_user+" at ");
			$("#update_time").html(toLocalTimeZone(result.mod_time));
		}
		else{
			$("#update_text").html();
			$("#update_time").html();
		}
		
		if (siteData.write) this.map.initControls();

	}

	buildAccountMenu(){
		const markup = `
			<a class="dropdown-item" target="_blank" href="${menu.account.url}">${menu.account.name}</a>
            <a class="dropdown-item" target="_blank" href="${menu.account.url}">${menu.sites.name}</a>
            <a class="dropdown-item" target="_blank" href="${menu.account.url}">${menu.docs.name}</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" target="_blank" href="${menu.account.url}">${menu.support.name}</a>
            <a class="dropdown-item" target="_blank" href="${menu.account.url}">${menu.logout.name}</a>
			`;
		$("#accounts-menu").html(markup);

	}

	attachObserver(){
		drawObserver.subscribe(updateMap);
		var app = this;
		window.setInterval(function(){
			drawObserver.notify(app);
		},30000); 
	}

	showTutorial(){
		const driver = new Driver({allowClose: false,animate: true,closeBtnText: '',nextBtnText: 'Next »',prevBtnText: '« Previous',});
		$('#select-button').parent().attr('id','select-c');
		$('#modify-button').parent().attr('id','modify-c');
		$('#node-config-button').parent().attr('id','node-config-c');
		$('#draw-route-button').parent().attr('id','draw-route-c');
		$('#draw-poly-button').parent().attr('id','draw-poly-c');
		$('#split-button').parent().attr('id','split-c');

		
		// Define the steps for introduction
		driver.defineSteps([
			{
			element: '#select-c',
			stageBackground: 'transparent',
			popover: {
				className: 'first-step-popover-class select-c',
				title: 'Select',
				description: 'Select routes and delete routes',
				position: 'right'
			},
			onClose: () => {localStorage.setItem('guideUIcompleted',true);},
			},
			{
			element: '#modify-c',
			stageBackground: 'transparent',
			popover: {
				className: 'modify-c',
				title: 'Modify',
				description: 'Click and drag to change or modify position of nodes.',
				position: 'right'
			}
			},
			{
			element: '#node-config-c',
			stageBackground: 'transparent',
			popover: {
				className: 'node-config-c',
				title: 'Node Config',
				description: 'Configure nodes. Attribute point, becon or both to the respective node.',
				position: 'right'
			}
			},
			{
			element: '#draw-route-c',
			stageBackground: 'transparent',
			popover: {
				className: 'draw-route-c',
				title: 'Draw Route',
				description: 'Plot routes on the given map.',
				position: 'right'
			}
			},
			{
			element: '#draw-poly-c',
			stageBackground: 'transparent',
			popover: {
				className: 'draw-poly-c',
				title: 'Polygon',
				description: 'Draw and mark areas.',
				position: 'right'
			}
			},
			{
			element: '#split-c',
			stageBackground: 'transparent',
			popover: {
				className: 'split-c',
				title: 'Route Points',
				description: 'Add additional points between two nodes.',
				position: 'right'
			},
			},
			{
			element: '#save-data',
			stageBackground: '#fff',
			popover: {
				className: 'save-data-c',
				title: 'Save',
				description: 'Save current modification on the map apart from auto save.',
				position: 'left'
			}
			},
			{
			element: '#profile-c',
			stageBackground: '#fff',
			popover: {
				className: 'profile-c',
				title: 'Profile',
				description: 'User/organisation infromations.',
				position: 'left'
			}
			},
			{
			element: '.map-legend',
			stageBackground: 'transparent',
			popover: {
				className: 'map-legend-c',
				title: 'Map Legend',
				description: 'Map style and icon information.',
				position: 'left'
			},
			onNext: () => {localStorage.setItem('guideUIcompleted',true);},
			},
		]);
		
		// Start the introduction
		driver.start();

	}

}